import { requestGet } from '@/common/request'

export default {
  // 我的活动列表
  async fetchGetResource (query) {
    return await requestGet('/resource/getResource', query)
  }
}
